import styled from 'styled-components';

export const FundRowStyle = styled.div`
  grid-template-columns: repeat(2, minmax(0, 1fr));
  display: grid;
  border-bottom: 1px solid #cdd4df;

  &:last-child {
    border-bottom: none;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.no-mapped {
      background: #f8f9fa;
      color: #adb5bd;
    }
    &:first-child {
      border-right: 1px solid #cdd4df;
    }

    button {
      padding: 0;
      border: none;
    }

    padding: 22px 16px;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
`;
